import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { MatMenuModule } from "@angular/material/menu";
import { CommonModule } from "@angular/common";
import { OverlayRef } from "@angular/cdk/overlay";
import { CardActionMenu } from "./card-action-menu.models";
import { boostThemeEnum } from "@app/services/page.service";
import { Overlay } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { CardModel } from "src/swagger/api.client.generated";
@Component({
  selector: "app-card-action-menu",
  templateUrl: "./card-action-menu.component.html",
  styleUrls: ["./card-action-menu.component.scss"],
  standalone: true,
  imports: [CommonModule, MatMenuModule, AngularSvgIconModule],
})
export class CardActionMenuComponent {
  @Input() card: CardModel;
  @Input() iconThemeColor: boostThemeEnum = boostThemeEnum.forestpath;
  @Input() isEditable: boolean = false;
  /** When the editable card is a not-yet-created custom card, the edit item is shown as CREATE. */
  @Input() isCreate: boolean = false;
  @Input() showSwap: boolean = true;
  @Input() canDelete: boolean = true;
  @Input() canDuplicate: boolean = true;
  @Input() canRemove: boolean = false;

  @Output() actionClicked = new EventEmitter<CardActionMenu>();

  activeItem: CardActionMenu | null = null;

  onActionClicked(action: CardActionMenu) {
    this.activeItem = action;
    this.actionClicked.emit(action);
    this.closeMenu();
  }

  @ViewChild("menu") menuTemplate!: TemplateRef<any>;
  private overlayRef: OverlayRef | null = null;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private el: ElementRef
  ) {}

  openMenu() {
    this.closeMenu();
    this.actionClicked.emit("open");

    const cardFontSizePx = parseFloat(getComputedStyle(this.el.nativeElement).fontSize);
    const offsetY = Math.round(-1.75 * cardFontSizePx);

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.el.nativeElement)
      .withPositions([
        {
          originX: "end",
          originY: "bottom",
          overlayX: "start",
          overlayY: "top",
        },
      ])
      .withDefaultOffsetX(0)
      .withDefaultOffsetY(offsetY);
    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: "cdk-overlay-transparent-backdrop",
    });
    this.overlayRef.hostElement.style.fontSize = `${cardFontSizePx}px`;

    this.overlayRef.attach(
      new TemplatePortal(this.menuTemplate, this.viewContainerRef)
    );
    this.overlayRef.backdropClick().subscribe(() => this.closeMenu());
  }

  closeMenu() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
